import { render } from "./FilterKecamatan.vue?vue&type=template&id=9b5e1a20"
import script from "./FilterKecamatan.vue?vue&type=script&lang=js"
export * from "./FilterKecamatan.vue?vue&type=script&lang=js"
script.render = render

export default script